import React from "react";
import classNames from "classnames";
import { SharedPDFViewer } from "@/features/previews/shared/components/SharedPDFViewer";
import { PreviewCloudinaryImage } from "@/features/previews/shared/components/PreviewCloudinaryImage";
import { IoImageOutline } from "react-icons/io5";

interface DocumentViewerContainerProps {
  isInitPreview: boolean;
  pdfFileUrl?: string;
  logoUrl?: string;
}

export const DocumentViewerContainer: React.FC<DocumentViewerContainerProps> = ({
  isInitPreview,
  pdfFileUrl,
  logoUrl,
}) => {
  const cardClasses = classNames("pdf-preview__card", {
    "pdf-preview__card--init-preview": isInitPreview,
    "u-card u-spacing-3": !isInitPreview && pdfFileUrl,
  });

  return (
    <div className={cardClasses}>
      {isInitPreview ? (
        <div className="pdf-preview__empty">
          <PreviewCloudinaryImage
            src={logoUrl}
            variant={"cover" as any}
            alt="pdf menu preview"
            isInitPreview={isInitPreview}
            placeholderClass="skeleton-placeholder__pdf__image"
          />
        </div>
      ) : (
        <>
          {pdfFileUrl ? (
            <SharedPDFViewer
              fileUrl={pdfFileUrl}
              className="pdf-preview__box"
            />
          ) : (
            <div className="pdf-preview__empty">
              <IoImageOutline style={{ color: "white", height: "100%", width: "80%" }} />
            </div>
          )}
        </>
      )}
    </div>
  );
};
